import Interceptors, { IAxiosRequestConfig } from './Interceptors';

class Http extends Interceptors {
  request<T>(config: IAxiosRequestConfig) {
    const requestMethod = this.instance.request<T>(config);
    return requestMethod
      .then((res: any) => {
        if (res.code || res.code === 0) {
          return res;
        } else {
          return res.data;
        }
      })
      .catch((e) => {
        return Promise.reject(e);
      }) as any;
  }

  get<T>(url: string, config?: IAxiosRequestConfig) {
    return this.request<T>({ url, method: 'GET', ...config });
  }

  post<T>(url: string, data?: any, config?: IAxiosRequestConfig) {
    return this.request<T>({ method: 'POST', url, data, ...config });
  }

  patch<T>(url: string, data?: any, config?: IAxiosRequestConfig) {
    return this.request<T>({ method: 'PATCH', url, data, ...config });
  }

  put<T>(url: string, data?: any, config?: IAxiosRequestConfig) {
    return this.request<T>({ method: 'PUT', url, data, ...config });
  }

  del<T>(url: string, data?: any, config?: IAxiosRequestConfig) {
    return this.request<T>({ method: 'DELETE', url, data, ...config });
  }

  remove<T>(url: string, data?: any, config?: IAxiosRequestConfig) {
    return this.request<T>({ method: 'DELETE', url, data, ...config });
  }
}
const rawHttp = new Http();

/** 自定义hooks */
export function useHttp() {
  return rawHttp;
}

export default rawHttp;
